import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import NewHeader from './components/redesign/NewHeader';
import NewHero from './components/redesign/NewHero';
import Section01Problem from './components/redesign/Section01Problem';
import Section02WhyFails from './components/redesign/Section02WhyFails';
import Section03Insight from './components/redesign/Section03Insight';
import Section04Approach from './components/redesign/Section04Approach';
import Section05Contrast from './components/redesign/Section05Contrast';
import Section07Technology from './components/redesign/Section07Technology';
import Section09CTA from './components/redesign/Section09CTA';
import NewFooter from './components/redesign/NewFooter';
import PrivacyPolicy from './components/redesign/PrivacyPolicy';
import Spheres3D from './components/redesign/Spheres3D';
import PlatformOverview from './components/redesign/PlatformOverview';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-navy text-white relative">
        {/* Fixed 3D sphere field – the single background for the whole
            site. Hero is transparent so the spheres read full-strength;
            every other section sits on a tuned `.section-glass` plate
            (12px blur, no saturate) that softens the animated field
            beneath editorial copy without pegging the GPU. Mobile and
            reduced-transparency users get an opaque tint instead. */}
        <Spheres3D />

        <div className="relative" style={{ zIndex: 1 }}>
          <NewHeader />
          <Routes>
            <Route
              path="/"
              element={
                <main>
                  <NewHero />
                  <Section01Problem />
                  <Section02WhyFails />
                  <Section03Insight />
                  <Section04Approach />
                  <Section05Contrast />
                  <Section07Technology />
                  <Section09CTA />
                </main>
              }
            />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/platform" element={<PlatformOverview />} />
          </Routes>
          <NewFooter />
        </div>
      </div>
    </Router>
  );
}

export default App;
